import { api } from "./client";

export const attachmentsApi = {
  upload: (
    base64: string,
    contentType: string,
    filename?: string,
  ): Promise<{ url: string; filename: string | null; isImage: boolean }> =>
    api
      .post<{ url: string; filename: string | null; isImage: boolean }>("/attachments", {
        data: base64,
        contentType,
        filename,
      })
      .then((r) => r.data),
};
